(() => {
  const root = document.querySelector('[data-swg-home]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    const revealGroups = [
      ['.swg-section-intro > *, .swg-story__image, .swg-story__copy > *, .swg-manifesto .swg-shell > *, .swg-textures .swg-shell > .swg-eyebrow, .swg-textures .swg-shell > h2, .swg-benefits .swg-shell > .swg-eyebrow, .swg-benefits .swg-shell > h2, .swg-testimonials .swg-shell > *, .swg-shop .swg-shell > .swg-eyebrow, .swg-shop .swg-shell > h2, .swg-product, .swg-faq__grid > *, .swg-closing .swg-shell > *', 0],
      ['.swg-step-grid > *, .swg-method__benefits > *, .swg-benefit-grid > *', 90],
    ];

    const revealItems = [];
    revealGroups.forEach(([selector, stagger]) => {
      root.querySelectorAll(selector).forEach((element, index) => {
        element.classList.add('swg-reveal');
        element.style.setProperty('--swg-delay', `${Math.min(index * stagger, 360)}ms`);
        revealItems.push(element);
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    revealItems.forEach((element) => observer.observe(element));

    requestAnimationFrame(() => root.classList.add('is-ready'));

    const heroVisual = root.querySelector('.swg-hero__visual');
    const storyImage = root.querySelector('.swg-story__image img');
    const allowParallax = window.matchMedia('(min-width: 901px) and (pointer: fine)').matches;
    if (allowParallax && (heroVisual || storyImage)) {
      let ticking = false;
      let storyTop = 0;
      let storyHeight = 0;
      const measureStory = () => {
        if (!storyImage) return;
        const rect = storyImage.getBoundingClientRect();
        storyTop = rect.top + window.scrollY;
        storyHeight = rect.height;
      };
      const updateDrift = () => {
        const y = window.scrollY;
        if (heroVisual && y < 1200) heroVisual.style.setProperty('--swg-drift', `${Math.min(y * 0.045, 28)}px`);
        if (storyImage && y + window.innerHeight * 1.5 > storyTop && y < storyTop + storyHeight + window.innerHeight) {
          const centerOffset = storyTop + storyHeight / 2 - y - window.innerHeight / 2;
          storyImage.style.setProperty('--swg-drift', `${Math.max(-18, Math.min(18, centerOffset * -0.025))}px`);
        }
        ticking = false;
      };
      const scheduleDrift = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateDrift);
      };
      measureStory();
      updateDrift();
      window.addEventListener('scroll', scheduleDrift, { passive: true });
      window.addEventListener('resize', () => {
        measureStory();
        scheduleDrift();
      }, { passive: true });
    }

    const motionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-motion-active', entry.isIntersecting && !document.hidden));
    }, { rootMargin: '120px 0px' });
    root.querySelectorAll('.swg-announcement, .swg-hero, .swg-testimonials').forEach((element) => motionObserver.observe(element));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) root.querySelectorAll('.is-motion-active').forEach((element) => element.classList.remove('is-motion-active'));
      else root.querySelectorAll('.swg-announcement, .swg-hero, .swg-testimonials').forEach((element) => motionObserver.unobserve(element) || motionObserver.observe(element));
    });
  } else {
    root.classList.add('is-ready');
  }

  root.querySelectorAll('[data-swg-textures] button').forEach((button) => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-swg-textures] button').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      const result = root.querySelector('.swg-texture-result');
      result?.classList.add('is-changing');
      window.setTimeout(() => {
        root.querySelector('[data-swg-texture-copy]').textContent = button.dataset.copy || '';
        root.querySelector('[data-swg-texture-label]').textContent = button.dataset.label || '';
        result?.classList.remove('is-changing');
      }, reduceMotion ? 0 : 180);
    });
  });

  root.querySelectorAll('[data-swg-quantity]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.swg-quantity')?.querySelector('[data-swg-quantity-input]');
      if (!input) return;
      const current = Number.parseInt(input.value, 10) || 1;
      input.value = String(button.dataset.swgQuantity === 'plus' ? current + 1 : Math.max(1, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  root.querySelector('[data-swg-cart]')?.addEventListener('click', () => {
    const drawer = root.querySelector('.swg-native-actions cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  });

  const addButton = root.querySelector('.swg-add[type="submit"]');
  const addForm = addButton?.closest('form');
  const cartButton = root.querySelector('[data-swg-cart]');
  const cartToast = document.createElement('div');
  let addResetTimer;
  let toastTimer;
  let pendingAdd = false;

  cartToast.className = 'swg-cart-toast';
  cartToast.dataset.swgCartToast = '';
  cartToast.setAttribute('role', 'status');
  cartToast.setAttribute('aria-live', 'polite');
  cartToast.setAttribute('aria-atomic', 'true');
  cartToast.setAttribute('aria-hidden', 'true');
  cartToast.innerHTML = '<span class="swg-cart-toast__check" aria-hidden="true">✓</span><span>Added to your bag</span>';
  root.appendChild(cartToast);

  const resetAddButton = () => {
    if (!addButton) return;
    addButton.classList.remove('is-adding', 'is-added', 'is-error');
    addButton.removeAttribute('aria-busy');
    addButton.textContent = addButton.dataset.defaultText || 'Add to Bag';
  };

  const showAdded = () => {
    if (!addButton) return;
    window.clearTimeout(addResetTimer);
    window.clearTimeout(toastTimer);
    addButton.classList.remove('is-adding', 'is-added', 'is-error');
    void addButton.offsetWidth;
    addButton.classList.add('is-added');
    addButton.removeAttribute('aria-busy');
    addButton.textContent = 'Added ✓';
    cartButton?.classList.remove('is-cart-pulsing');
    void cartButton?.offsetWidth;
    cartButton?.classList.add('is-cart-pulsing');
    cartToast.classList.remove('is-visible');
    void cartToast.offsetWidth;
    cartToast.removeAttribute('aria-hidden');
    cartToast.classList.add('is-visible');
    addResetTimer = window.setTimeout(resetAddButton, 2400);
    toastTimer = window.setTimeout(() => {
      cartToast.classList.remove('is-visible');
      cartToast.setAttribute('aria-hidden', 'true');
    }, 2800);
  };

  addForm?.addEventListener('submit', () => {
    if (!addButton || addButton.disabled) return;
    pendingAdd = true;
    window.clearTimeout(addResetTimer);
    window.clearTimeout(toastTimer);
    cartToast.classList.remove('is-visible');
    cartToast.setAttribute('aria-hidden', 'true');
    addButton.dataset.defaultText ||= addButton.textContent.trim();
    addButton.classList.remove('is-added', 'is-error');
    addButton.classList.add('is-adding');
    addButton.setAttribute('aria-busy', 'true');
    addButton.textContent = 'Adding…';
  });

  const mobileBuy = root.querySelector('.swg-mobile-buy');
  const updateMobileBuy = () => mobileBuy?.classList.toggle('is-visible', window.scrollY > 650);
  updateMobileBuy();
  window.addEventListener('scroll', updateMobileBuy, { passive: true });

  document.addEventListener('cart:update', (event) => {
    const count = event.detail?.resource?.item_count;
    if (Number.isInteger(count)) root.querySelector('[data-swg-cart-count]').textContent = `(${count})`;
    if (!pendingAdd) return;
    pendingAdd = false;
    if (event.detail?.data?.didError) {
      resetAddButton();
      return;
    }
    showAdded();
  });

  document.addEventListener('cart:error', () => {
    if (!pendingAdd || !addButton) return;
    pendingAdd = false;
    addButton.classList.remove('is-adding');
    addButton.classList.add('is-error');
    addButton.removeAttribute('aria-busy');
    addButton.textContent = 'Please try again';
    window.clearTimeout(addResetTimer);
    addResetTimer = window.setTimeout(resetAddButton, 2600);
  });
})();
